import React, { useState } from "react";

const BetCard = ({ bet }) => (
  <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-lg p-3">
    <div className="flex justify-between items-start mb-2">
      <div>
        <h3 className="text-sm font-medium text-white">{bet.matchName}</h3>
        <p className="text-xs text-gray-400">{bet.betType}</p>
      </div>
      <div
        className={`px-2 py-0.5 rounded text-xs font-medium ${
          bet.status === "Won"
            ? "bg-green-500/20 text-green-400"
            : bet.status === "Lost"
            ? "bg-red-500/20 text-red-400"
            : "bg-blue-500/20 text-blue-400"
        }`}
      >
        {bet.status}
      </div>
    </div>
    <div className="border-t border-gray-700/50 pt-2 mt-2">
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div>
          <span className="text-gray-400">Bet Amount:</span>
          <span className="text-white ml-1">₹{bet.amount}</span>
        </div>
        <div className="text-right">
          <span className="text-gray-400">Odds:</span>
          <span className="text-white ml-1">{bet.odds}</span>
        </div>
        <div>
          <span className="text-gray-400">Potential Win:</span>
          <span className="text-white ml-1">₹{bet.potentialWin}</span>
        </div>
        <div className="text-right">
          <span className="text-gray-400">Payout:</span>
          <span className="text-white ml-1">₹{bet.payout || 0}</span>
        </div>
      </div>
    </div>
  </div>
);

const BetHistoryPage = () => {
  const [activeTab, setActiveTab] = useState("active");

  const tabs = [
    { id: "active", label: "Active Bets" },
    { id: "settled", label: "Settled" },
    { id: "canceled", label: "Canceled" },
  ];

  const bets = [
    {
      id: 1,
      matchName: "Mumbai Indians vs Chennai Super Kings",
      betType: "Winner (Incl. Super Over) - Mumbai Indians",
      status: "Active",
      amount: 500,
      odds: "1.85",
      potentialWin: "925.00",
      date: "2024-02-20",
    },
    {
      id: 2,
      matchName: "Srilankan Lions vs Indian Royals",
      betType: "Most Sixes - Indian Royals",
      status: "Won",
      amount: 1000,
      odds: "2.65",
      potentialWin: "2650.00",
      payout: "2650.00",
      date: "2024-02-19",
    },
    // Add more bet history items
  ];

  const filteredBets = bets.filter(
    (bet) =>
      bet.status.toLowerCase() === activeTab ||
      (activeTab === "settled" && ["Won", "Lost"].includes(bet.status))
  );

  return (
    <div className="min-h-screen bg-gray-900 pb-8">
      <div className="">
        <h1 className="text-2xl font-bold text-white mb-6">Bet History</h1>

        {/* Tabs */}
        <div className="flex space-x-2 mb-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all
                ${
                  activeTab === tab.id
                    ? "bg-blue-600 text-white"
                    : "bg-gray-800/50 text-gray-400 hover:bg-gray-800"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Bets List */}
        <div className="space-y-3">
          {filteredBets.map((bet) => (
            <BetCard key={bet.id} bet={bet} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BetHistoryPage;
